import { IIconBase } from '..'

const InfoIcon = ({
  color = '#DC3545',
  height = 18,
  width = 18,
}: IIconBase) => {
  return (
    <svg width={width} height={height} viewBox='0 0 18 18' fill='none'>
      <g id='icon-wrapper'>
        <path
          id='Union'
          fillRule='evenodd'
          clipRule='evenodd'
          d='M9 2.74902C5.54822 2.74902 2.75 5.54724 2.75 8.99902C2.75 12.4508 5.54822 15.249 9 15.249C12.4518 15.249 15.25 12.4508 15.25 8.99902C15.25 5.54724 12.4518 2.74902 9 2.74902ZM1.75 8.99902C1.75 4.99496 4.99594 1.74902 9 1.74902C13.0041 1.74902 16.25 4.99496 16.25 8.99902C16.25 13.0031 13.0041 16.249 9 16.249C4.99594 16.249 1.75 13.0031 1.75 8.99902ZM8.33449 5.05785C8.42905 4.95654 8.56142 4.89902 8.7 4.89902H9.3C9.43858 4.89902 9.57095 4.95654 9.66551 5.05785C9.76008 5.15916 9.80835 5.29517 9.79881 5.43342L9.49882 9.78342C9.48073 10.0456 9.26279 10.249 9 10.249C8.73721 10.249 8.51927 10.0456 8.50118 9.78342L8.20118 5.43342C8.19165 5.29517 8.23992 5.15916 8.33449 5.05785ZM9.9 12.299C9.9 12.7961 9.49706 13.199 9 13.199C8.50294 13.199 8.1 12.7961 8.1 12.299C8.1 11.802 8.50294 11.399 9 11.399C9.49706 11.399 9.9 11.802 9.9 12.299Z'
          fill={color}
        />
      </g>
    </svg>
  )
}

export default InfoIcon
